<template>
  <div class="box profile-card-2">
    <div class="row">
      <div class="col-6" style="text-align: left">
        <span class="start_up_label">Tech Stack</span>
      </div>
      <div
        class="col-6"
        style="text-align: right"
        data-bs-toggle="modal"
        data-bs-target="#editTechStack"
      >
        <span class="start_up_edit">Edit</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="row investor_list">
          <div class="investor_data" v-for="(data, i) in form.stack" :key="i">
            {{ data }} 
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="editTechStack"
      tabindex="-1"
      aria-labelledby="editTechStackLabel"
      aria-hidden="true"
      style=""
    >
      <div class="modal-dialog" style="width: 550px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Tech-Stack</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit="updateTechStack">
            <div class="modal-body" style="padding: 30px; padding-top: 50px">
              <div v-if="fetchStackError != ''">
                <center>
                  <br />
                  <img
                    src="/img/cancel.png"
                    style="margin-top: 30px; width: 150px"
                  /><br /><br />
                  <p style="margin-top: 30px">
                    Error detected while loading tech-stack
                  </p>
                  <code>{{ this.fetchStackError }}</code>
                  <br /><br />
                </center>
              </div>
              <div class="form-grouped">
                <div class="list-wrapper" v-if="isLoadingTools == true">
                  <img
                    src="/img/lightbox/preloader.gif"
                    style="margin-left: 10px"
                    class="button-spinner"
                  />
                </div>
                <div class="list-wrapper" v-if="isLoadingTools == false">
                  <!-- :buttonIcon="'img/interests/' + item.img" -->
                  <ChipButton
                    v-for="(item, index) in projectToolsData"
                    :key="index"
                    :text="item.name"
                    :dashedBorder="true"
                    :selected="checkedSelectedItem(item.name)"
                    v-on:click="handleSelectIndustry(item.name)"
                  />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div
                v-if="isUpdateTechStack"
                style="right: 0%; right: 0; margin-top: 0%; text-align: center"
                id="loaderCal"
              >
                <v-progress-circular
                  :size="30"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                {{ "updating tech-stack..." }}
              </div>

              <button
                v-if="!isUpdateTechStack"
                type="button"
                class="btn btn-light lightBorder p-3"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>

              <button
                v-if="!isUpdateTechStack && fetchStackError == ''"
                type="submit"
                class="btn btn-primary p-3"
              >
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="errorModalTechStack"
      tabindex="-1"
      aria-labelledby="errorModalTechStackLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 450px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ERROR DETECTED</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="text-align: center">
            <br />
            <img
              src="/img/cancel.png"
              style="margin-top: 30px; width: 150px"
            /><br /><br />
            <p style="margin-top: 30px">
              Error detected while updating tech-stack
            </p>
            <code>{{ this.TeckStackUpdateError }}</code>
            <br /><br />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light lightBorder"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal"
      id="successChangeRequestModalTechStack"
      tabindex="-1"
      aria-labelledby="successChangeRequestModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" style="width: 450px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Tech-stack Updated</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body" style="text-align: center">
            <br />
            <img
              src="/img/marked.svg"
              style="margin-top: 30px; width: 150px"
            /><br /><br />
            <p style="margin-top: 30px">
              Tech-stack record updated successfully
            </p>
            <br /><br />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              data-bs-dismiss="modal"
              class="btn btn-light lightBorder"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateTechStack } from "@/api/client";
import ChipButton from "@/components/chipButton/chipButton";
import { fetchToolsAndFrameWorks } from "@/api";

import { mapActions } from "vuex";

export default {
  props: ["form", "project_id", "startup_id"],
  data: () => ({
    TeckStackUpdateError: "",
    fetchStackError: "",
    projectToolsData: [],
    isLoadingTools: false,
    isUpdateTechStack: false,
  }),
  components: {
    ChipButton,
  },
  created() {
    fetchToolsAndFrameWorks()
      .then((output) => {
        if (output.data.status == 1) {
          //  this.projectToolsData = response.data.data;
          // console.log(output.data.data);
          this.isLoadingTools = false;
          let response = output.data.data.sort(function (a, b) {
            return a.name - b.name;
          });

         // let b = this.getStackTools(response, "language");

          let b = response;// this.getStackTools(response, "language");

          // console.log(b);
          this.fetchStackError = "";

          for (var i = 0; i < b.length; i++) {
            this.projectToolsData.push({
              name: response[i].name,
              tag: response[i]._type,
              id: response[i].id,
            });
          }

          // console.log(this.projectToolsData);
        }
      })
      .catch((err) => {
        this.isLoadingTools = false;
        // console.log(err);
        this.fetchStackError = err;
      });
  },

  computed: {
    checkedSelectedItem() {
      return (value, type) => {
        let selected = this.form.stack;
        const foundItem = selected.find((item) => item == value);
        return foundItem ? true : false;
      };
    },
  },
  mounted() {
    // console.log("form:: ", this.form.stack);
    // console.log("all:: ", this.projectToolsData);
  },
  methods: {
    ...mapActions("clientDashboard", ["updateProject"]),
    getStackTools(data, value) {
      // console.log(data);
      const language = data.filter((item) => item._type == value);
      return language;
    },
    handleSelectIndustry(value) {
      let selected = this.form.stack;
      const currentValue = selected.find((item) => item == value);
      if (!currentValue) {
        this.form.stack.push(value);
      } else {
        this.form.stack = selected.filter((item) => item !== value);
      }
      this.form_errors.industry = [];
    },
   
    async updateTechStack(event) {
      event.preventDefault();

      const payload = {
        project_id: this.project_id,

        stack: this.form.stack,
        startup_id: this.startup_id,
      };

      this.isUpdateTechStack = true;

      //stack
      await updateTechStack(payload)
        .then(async (response) => {
          this.isUpdateTechStack = false;
          $("#editTechStack").modal("hide");

          const { project } = response.data.data;

          if (response.data.status == 1) {
            this.updateProject(project);

            $("#successChangeRequestModalTechStack").modal("show");

            //
          } else {
            this.TeckStackUpdateError = response.data.errors;
            $("#errorModalTechStack").modal("show");
          }
        })
        .catch((error) => {
          $("#editTechStack").modal("hide");
          this.isUpdateTechStack = false;
          if (error.hasOwnProperty("message")) {
            this.TeckStackUpdateError = error.message;
          } else {
            this.TeckStackUpdateError = error.data.errors;
          }

          $("#errorModalTechStack").modal("show");
        });

      //console.log(payload);
    },
  },
};
</script>

<style scoped>
.lightBorder {
  border: 1px solid #eee;
}
.modal {
  text-align: center;
}

@media screen and (min-width: 768px) {
  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.modal_label {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 145%;
  /* identical to box height, or 20px */

  display: flex;
  align-items: center;

  /* primary/700 (text) */

  color: #1b1e22;
  padding-bottom: 10px;
}

.profile-card-2 {
  text-align: left;
  background: #ffffff;

  border-bottom: 1px solid #eee;
  padding: 20px;
}
.start_up_line {
  border: 0.5px solid #e4e5e7;
}

.start_up_data {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  padding-top: 30px;
  padding-bottom: 20px;

  color: #1b1e22;
}
.start_up_edit {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;

  text-align: right;
  cursor: pointer;
  color: #0781f2;
}
.start_up_label {
  font-family: "Moderat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;

  text-transform: uppercase;

  color: #979da5;
}

.investor_data {
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 12px;
  gap: 8px;
  width: auto;

  height: 31px;

  /* primary/0 */

  background: #ffffff;
  /* primary/100 */

  border: 1px solid #e4e5e7;
  border-radius: 8px;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.investor_list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  padding: 20px;
  padding-top: 20px;
}

div.title {
  text-align: left;
  padding-top: 56px;
  padding-left: 5px;
  font-size: 23px;
  font-weight: bold;
}
.form-container {
  width: 588px;
  padding-top: 20px;
}
.div-label {
  text-align: left;
  font-size: 14px;
  padding-bottom: 5px;
  font-size: 14px;
  line-height: 145%;
}
.form-control {
  border: 1px solid #e4e5e7;
}
.form-control {
  margin-top: 4px;
  margin-bottom: 0px;
}
.form-grouped {
  margin-top: 0px;
}

.form_errors {
  color: red;
}
.check-product-name {
  text-align: left;
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #1b1e22;
  margin-top: 8px;
}
.light-label {
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #979da5;
  margin-top: 8px;
  text-align: left;
}
.chip-btn-container {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.button-container {
  /*display: flex;*/
  justify-content: flex-end;
  margin: 48px 0px;
  float: left;
}
.text-box-hint {
  font-size: 14px;
  line-height: 130%;
  color: #979da5;
  text-align: left;
  margin-top: 8px;
}
.medium-combo-box .v-text-field {
  border: 1px solid #e4e5e7;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  line-height: 130%;
}

.textbox-wrapper {
  display: flex;
}
.textbox-wrapper div {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  /* background-color: #fff; */
  margin-top: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 0;
  width: 42px;
  background: black;
  color: white;
  height: 51px;
}
.light-text-label {
  color: #979da5;
}
.display-inline {
  display: inline-block;
  /* padding-top: 50px; */
}
.list-wrapper {
  display: flex;
  margin-top: 5px;
  gap: 12px;
  width: 100%;
  flex-wrap: wrap;
}
.label-description {
  color: #979da5;
}
.brief_counter {
  margin-bottom: 28px;
}
@media (max-width: 768px) {
  .form-container {
    width: 100%;
  }
  .button-container {
    float: none;
  }
  .grupa-blue-btn {
    width: 100%;
  }
  .list-wrapper {
    width: 100%;
  }
  div.title {
    padding-top: 32px;
  }
  .chip-btn-container {
    width: 100%;
  }
  .form-grouped {
    margin-top: 32px;
  }
}
</style>
